import { useState, useCallback, useEffect } from "react";

export function useAuthLocalStorage() {
  const [token, setToken] = useState(null);


  useEffect(() => {
    const stored = localStorage.getItem("token");
    if (stored) {
      setToken(stored);
    }
  }, []);

  const saveToken = useCallback((newToken) => {
    if (!newToken) return;
    localStorage.setItem("token", newToken);
    setToken(newToken);
  }, []);

  const removeToken = useCallback(() => {
    localStorage.removeItem("token");
    setToken(null);
  }, []);

  return { token, saveToken, removeToken };
}